import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ConnectivityService } from './connectivity.service';

/**
 * Surfaces a global banner for connection/server failures (status 0 - unreachable, or 5xx) so they
 * read differently from a genuine empty result. 401 is left to authInterceptor (redirects to login);
 * every other 4xx is left to the calling component (validation/permission errors already have their
 * own inline messaging, e.g. "Could not save. Check the fields...").
 */
export const connectivityInterceptor: HttpInterceptorFn = (req, next) => {
  const connectivity = inject(ConnectivityService);

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 0 || error.status >= 500) {
        connectivity.reportError();
      }
      return throwError(() => error);
    })
  );
};
